import { render, staticRenderFns } from "./RegisterStep.vue?vue&type=template&id=5804fd6e&scoped=true"
import script from "./RegisterStep.vue?vue&type=script&lang=js"
export * from "./RegisterStep.vue?vue&type=script&lang=js"
import style0 from "./RegisterStep.vue?vue&type=style&index=0&id=5804fd6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5804fd6e",
  null
  
)

export default component.exports